import { FormattedMessage } from "react-intl";
import { useFieldArray, useFormContext } from "react-hook-form";

import "../Schedule.scss";
import { ICountries } from "pages/shipper/RequestForm/components/Schedule/Types";
import FlightComponent from "./FlightComponent";

const customFlightInfo = {
  airline_code: "",
  flight_number: null,
  departure_date: null,
  departure_time: null,
  departure_airport_code: "",
  arrival_date: null,
  arrival_time: null,
  arrival_airport_code: "",
};

interface AirFreightProps {
  countries: ICountries[];
}

function AirFreightDelivery(props: AirFreightProps) {
  const { countries } = props;

  const methods = useFormContext();
  const { fields, append, remove } = useFieldArray({
    name: "schedule.flights",
    control: methods.control,
    shouldUnregister: true,
  });

  return (
    <>
      {fields.map((airplane, index) => (
        <div key={airplane.id}>
          <FlightComponent index={index} countries={countries} remove={remove} />
        </div>
      ))}
      <div className="flex-row mt-4">
        <div className="w-192 align-date">
          <p onClick={() => append(customFlightInfo)} className="text-blue-200 font-b4 cursor-pointer">
            <FormattedMessage id="quote.provider.schedule.addFlight" defaultMessage="Add flight" />
          </p>
        </div>
      </div>
    </>
  );
}

export default AirFreightDelivery;
